import { defineMessages } from 'react-intl';

export default defineMessages({
	points_per_study: {
		id: 'rewards.points_per_study',
		defaultMessage: `Pilotly Points for every study`
	},
	rewards_error_loading_user: {
		id: 'rewards.error.user.loading',
		defaultMessage: "Loading user data failed",
	},
	rewards_error_updating_user: {
		id: 'rewards.error.user.updating',
		defaultMessage: "Updating user data failed",
	},
	rewards_error_loading_studies: {
		id: 'rewards.error.studies.loading',
		defaultMessage: "Retrieving studies failed",
	},
});



// WEBPACK FOOTER //
// ./src/locales/rewards.js